import { createApp } from 'vue';
import App from './App.vue';
// Input teléfono
import 'v-phone-input/dist/v-phone-input.css';
import { createVPhoneInput } from 'v-phone-input';
import { createVuetify } from 'vuetify';
import 'vuetify/styles';
import * as components from 'vuetify/components';
// Estilos
import './assets/css/app.css';

// Handshake genérico con el loader (iawidget.js) en la ventana padre.
function requestFromParent(tipoPeticion, tipoRespuesta) {
  return new Promise((resolve) => {
    window.parent.postMessage({ tipo_peticion: tipoPeticion }, '*');
    window.addEventListener('message', function handler(e) {
      const data = e.data;
      if (data && data.tipo === tipoRespuesta) {
        window.removeEventListener('message', handler);
        resolve(data);
      }
    });
  });
}

async function get_data_widget() {
  return requestFromParent('get_widget', 'get_widget');
}

// ─────────────────────────────────────────────────────────────
// Modo VOZ: monta el widget de voz (ElevenLabs) en vez del chat.
// El loader carga el iframe con ?mode=voice y responde a get_voice.
// ─────────────────────────────────────────────────────────────
if (new URLSearchParams(window.location.search).get('mode') === 'voice') {
  (async () => {
    // Fondo transparente: dentro del iframe solo debe verse la cápsula de voz.
    document.documentElement.style.background = 'transparent';
    document.body.style.background = 'transparent';
    const appEl = document.getElementById('app');
    if (appEl) appEl.style.background = 'transparent';
    const { default: VoiceWidget } = await import('./VoiceWidget.vue');
    const data = await requestFromParent('get_voice', 'get_voice');
    const app = createApp(VoiceWidget, {
      accessKey: data.access_key,
      idWidget: data.id_widget,
      language: data.language || 'es',
      voiceConfig: data.voiceConfig || {},
      functionsBase: data.functionsBase || '',
      // ponytail: requiere que el loader (iawidget.js) responda get_voice con info_user.
      // Hoy iawidget.js NO tiene handler get_voice → el embed de voz aún no está cableado.
      infoUser: data.info_user || {},
    });
    app.mount('#app');
  })();
} else {
(async () => {
  const widget = await get_data_widget();
  // Verificamos si existe el bloque extra de CSS en el widget y lo inyectamos en el head
  if (widget?.widget?.extra_css && widget.widget.extra_css.trim() !== '') {
    const styleEl = document.createElement('style');
    styleEl.innerHTML = widget.widget.extra_css;
    document.head.appendChild(styleEl);
  }
  // Creamos la app
  const app = createApp(App);
  app.config.globalProperties.widget = widget.widget;
  app.config.globalProperties.company = widget.company;
  app.config.globalProperties.name_company = widget.name_company;
  // Vuetify y vPhoneInput
  const vuetify = createVuetify({ components });
  const vPhoneInput = createVPhoneInput({
    enableSearchingCountry: true,
    defaultCountry: widget?.widget?.country_widget?.value || 'ES',
  });
  app.use(vPhoneInput);
  app.use(vuetify);
  app.mount('#app');
})();
}